type CurrencyCode = 'USD' | 'EUR' | 'JPY' | 'GBP';

const currencySymbols: Record<CurrencyCode, string> = {
    USD: '$',
    EUR: '€',
    JPY: '¥',
    GBP: '£',
};

const formatPrice = (price: number, fractionDigits: number = 2, currency?: CurrencyCode) => {
    const currencySymbol = currency ?? 'USD';

    // Intl.NumberFormat does not handle small numbers well. This handles
    // edge cases for small decimal numbers
    if (Math.abs(price) < 0.1) {
        return `${currencySymbols[currencySymbol]}${Number(price).toFixed(fractionDigits)}`;
    }

    return Intl.NumberFormat('en', {
        notation: 'compact',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
        currency: currencySymbol,
    }).format(price);
};

export type { CurrencyCode };
export { formatPrice };
